import type { ReactNode } from 'react'
import React from 'react'

import {
  AlignItems,
  Box,
  Color,
  Display,
  FlexDirection,
  Icon,
  IconVariant,
  JustifyContent,
} from '@gousto-internal/citrus-react'

type AlertVariant = 'info' | 'success' | 'danger'

type BoxSummaryAlertProps = {
  variant: AlertVariant
  children: ReactNode
  'data-testing'?: string
}

const alertStyles = {
  info: {
    bg: Color.Informative_50,
    iconName: 'info',
    iconVariant: IconVariant.Informative,
  },
  success: {
    bg: Color.Success_50,
    iconName: 'success',
    iconVariant: IconVariant.Confirmation,
  },
  danger: {
    bg: Color.Error_50,
    iconName: 'error',
    iconVariant: IconVariant.Error,
  },
} as const

export const BoxSummaryAlert = ({
  variant,
  children,
  'data-testing': dataTesting,
}: BoxSummaryAlertProps) => {
  const styles = alertStyles[variant]

  return (
    <Box
      bg={styles.bg}
      borderRadius={1.5}
      paddingH={3}
      paddingV={2}
      width="100%"
      display={Display.Flex}
      justifyContent={JustifyContent.Center}
      data-testing={dataTesting}
    >
      <Box display={Display.Flex} gap={2} width="100%">
        <Icon name={styles.iconName} variant={styles.iconVariant} size={5} />
        <Box
          display={Display.Flex}
          flexDirection={FlexDirection.Column}
          alignItems={AlignItems.FlexStart}
          width="100%"
        >
          {children}
        </Box>
      </Box>
    </Box>
  )
}
